import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { ErrorBoundaryProvider } from './providers/error-boundary';
import { ToastProvider } from './providers/toast-provider';
import { App } from './App';
import './index.css';
import { reportWebVitals } from './utils/web-vitals';
// Ensure SEOHead is available for lazy-loaded components
import './components/seo/seo-head';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <ErrorBoundaryProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </ErrorBoundaryProvider>
    </HelmetProvider>
  </StrictMode>
);

// Report web vitals
import { logger } from './utils/logger';
reportWebVitals((metric) => {
  logger.debug('Web Vital', metric);
});